// extracted by mini-css-extract-plugin
export default {"container":"Tiles_container__N-jSl","tileWrapper":"Tiles_tileWrapper__oThmq","tile":"Tiles_tile__Iu+vd"};